import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import PageLayout from '../components/PageLayout';
import {
  ShopContainer,
  ProductGrid,
  ProductCard,
  ProductImage,
  ProductInfo,
  ProductTitle,
  ProductPrice,
  ShopHeader,
  ShopTitle,
  Watermark
} from '../styles/ShopStyles';
import Footer from '../components/Footer';

const Shop = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  
  const formatPrice = (price) => {
    return `$${price.toFixed(2)}`;
  };

  const handleProductClick = (productId) => {
    navigate(`/shop/${productId}`);
  };

  useEffect(() => {
    axios.get('http://localhost:8000/products')
      .then(response => {
        setProducts(response.data);
      })
      .catch(error => {
        console.error('Error fetching products:', error);
      });
  }, []);

  return (
    <PageLayout>
      <ShopContainer>
        <Watermark>442</Watermark>
        <ShopHeader>
          <ShopTitle>Shop</ShopTitle>
        </ShopHeader>
        <ProductGrid>
          {products.map((product) => (
            <ProductCard 
              key={product._id}
              onClick={() => handleProductClick(product._id)}
            >
              <ProductImage>
                <img src={product.image} alt={product.name} />
              </ProductImage>
              <ProductInfo>
                <ProductTitle>{product.name}</ProductTitle>
                <ProductPrice>{formatPrice(product.price)}</ProductPrice>
              </ProductInfo>
            </ProductCard>
          ))}
        </ProductGrid>
        <Footer />
      </ShopContainer>
    </PageLayout>
  );
};

export default Shop;